import React from 'react';

//styling
import '../../../styles/loadingSpinner.scss'

export enum SpinnerSize {
    EXTRA_SMALL = 'xs-spinner',
    SMALL = 'small-spinner',
    MEDIUM = 'medium-spinner',
    LARGE = 'large-spinner'
}

const LoadingSpinner = ({spinnerSize}:{spinnerSize: SpinnerSize}) => {

    return <div className={`lds-spinner ${spinnerSize}`}><div /><div /><div /><div /><div /><div /><div /><div /></div>
}

export default LoadingSpinner